import { useState, useEffect } from 'react';
import { DeviceStorage } from '@catawiki/runtime-toolkit';
const USER_LOGGED_IN = 'userLoggedIn';
const USER_LOGGED_IN_EVENT = 'userLoggedInEvent';
export const useIsUserLoggedIn = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const setUserLoggedIn = () => setIsLoggedIn(true);
    useEffect(() => {
        if (DeviceStorage.get(USER_LOGGED_IN) === 'true') {
            setUserLoggedIn();
        }
        else {
            window.addEventListener(USER_LOGGED_IN_EVENT, setUserLoggedIn);
        }
        return () => window.removeEventListener(USER_LOGGED_IN_EVENT, setUserLoggedIn);
    }, []);
    return isLoggedIn;
};
//# sourceMappingURL=useIsUserLoggedIn.js.map